import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasketService } from '../basket.service';
import { Observable } from 'rxjs';
import { PurchaseTransaction } from '../purchase-transaction';

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.css']
})
export class PurchaseComponent implements OnInit {
 

  public purchase$: Observable<PurchaseTransaction>;
  serverData;
  redirectError;


  constructor(
    private basketService: BasketService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.serverData = this.basketService.serverData;
    this.basketService.serverData = undefined; // clear the data once we get it
    
    this.doCheckout();
    
  }



  async doCheckout()
  {
    if (!this.serverData) {
      this.redirectError = "Something went wrong processing your transaction. Please try again later. (No server data)"
      return;
    }
    const {error} = await stripe.redirectToCheckout({
      // Make the id field from the Checkout Session creation API response
      // available to this file, so you can provide it as parameter here
      // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
      sessionId: this.serverData.id
    });

    this.redirectError = error;
    console.log(error);
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `error.message`.
  }
}